import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (max-width: 767px) {
    max-width:calc(100vw - 30px);
  }
  .MuiAppBar-colorPrimary {
    background-color: transparent;
    box-shadow: none;
    padding-bottom: 25px;
  }
  .MuiTabScrollButton-root {
    width: 30px;
  }
  .MuiTab-textColorInherit.Mui-selected {
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiTab-textColorInherit {
    color: #7a7a7a;
    opacity: 1;
    text-transform: capitalize;
    font-size: 16px;
    font-family: "latomedium" !important;
  }
  .MuiTabs-indicator {
    background-color: #2fb5f1;
    height: 2px;
  }
  .MuiBox-root {
    padding: 0;
  }
`;

export { Container };